document.addEventListener('DOMContentLoaded', function() {
	const demoOverlay = document.getElementById('free-demo-overlay');

	document.addEventListener('click', function (e) {
		if (e.target.classList.contains("close-form") || e.target.classList.contains("hero__close-overlay")) {
			demoOverlay.style.display = 'none';
			document.body.classList.remove('modal-open');
		}

		if (e.target.classList.contains("open-free-demo-form") || e.target.classList.contains("calendly-free-demo")) {
			e.preventDefault();
			console.log('open free demo form');
			demoOverlay.style.display = 'block';
			document.body.classList.add('modal-open');
		}
	});
});



// WEBPACK FOOTER //
// ./scripts/modules/free-demo-popup.js